import React, { memo } from 'react';
import { useForm, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { TabsWrapper } from '../../../DealTypeTabs';
import { SearchTabs } from '../../../../ui/SearchTabs';
import { TabVariantEnum } from '../../../../ui/SearchTabs/types';
import { ItemCreateContactTypeEnum } from '../../../../../graphql/types';

const ownerType = [
  {
    value: ItemCreateContactTypeEnum.Owner,
    name: 'new_ad.i_am_owner',
    id: 'new-ad-form-owner'
  },
  {
    value: ItemCreateContactTypeEnum.Agent,
    name: 'new_ad.i_am_agent',
    id: 'new-ad-form-agent'
  }
];

const OwnerOrAgentComponent: React.FC = () => {
  const { t } = useTranslation();
  const { input: ownerField } = useField(FORM_VALUES.owner, {
    subscription: { value: true }
  });
  const { change } = useForm();

  const handleTabClick = (value: string) => {
    change(FORM_VALUES.owner, value);
  };

  const tabsTitles = ownerType.map(type => ({
    name: type.id,
    label: t(type.name),
    isSelected: type.value === ownerField.value,
    stat: type.id,
    onClick: () => handleTabClick(type.value)
  }));

  return (
    <TabsWrapper>
      <SearchTabs
        titles={tabsTitles}
        disabled={false}
        variant={TabVariantEnum.Blue}
        height={54}
      />
    </TabsWrapper>
  );
};

export const OwnerOrAgent = memo(OwnerOrAgentComponent);
